import { DEVICES } from '../../constants'

export const getLinkTarget = (shouldOpenInNewTab = false, layout) => {
  return shouldOpenInNewTab && layout === DEVICES.DESKTOP ? '_blank' : '_self'
}
